import { Outlet } from 'react-router';

const LandingLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <Outlet />
    </div>
  );
};

export default LandingLayout;
